module.exports = {
	"articleTitle1": "New college for sustainability proposed ",
	"catImage": "bluestar.png",
	"totalCats": 1,
	"name": "Dana Building",
	"articleLink1": "#",
	"articleLink2": "https://www.michigandaily.com/section/administration/university-sustainability-reports-shows-progress-almost-all-fields",
	"articleSnippet1": "Sep 14, 2016 ... The Samuel B. Dana building currently houses the School of Natural Resources \nand the Environment. Marissa Andreou/ Daily. Rachel Cohen.",
	"articleSnippet2": "Feb 20, 2017 ... University goes for gold in sustainability. The School of Natural Resources and \nthe Environment is housed in the Dana Building. File Photo/ ...",
	"totalMisc": 0,
	"articleTitle2": "University goes for gold in sustainability ",
	"address": "440 Church St, Ann Arbor, MI 48109",
	"images": [
		{
			"source": "https://www.michigandaily.com/sites/default/files/styles/large/public/160914/mna.FEA_.DRESSCLOTHINGCLOSET.9.14.16.262.jpg?itok=cwQeuTRM",
			"author": "Marissa Andreou",
			"caption": "The Samuel B. Dana building currently houses the School of Natural Resources and the Environment."
		},
		{
			"source": "https://www.michigandaily.com/sites/default/files/styles/large/public/161130/ara.NEW_.ClimateChange.11.29.16.054.jpg?itok=tv5vaFBO",
			"author": "Amanda Allen",
			"caption": "Engineering Prof. Richard Rood, who specializes in climate impact, speaks about climate change at \"Addressing Climate Change: US and International Policy for the 21st Century\" in the Dana Building Tuesday."
		},
		{
			"source": "https://www.michigandaily.com/sites/default/files/styles/large/public/161201/ara.NEW_.ClimateChange.11.29.16.090.jpg?itok=7Usxb6b9",
			"author": "Amanda Allen",
			"caption": "Sally Churchill, professor of environmental law and policy in the School of Natural Resources and Environment, holds up a copy of the New York Times as an example of how climate change issues are discussed frequently in the Dana Building Tuesday."
		}
	],
	"position": {
		"lat": 42.277318,
		"lng": -83.736589
	},
	"tips": [
		{
			"text": "The 4th floor is open air and you can see down below, there's lots of natural light which is nice to study in in the winter.",
			"person": "Shivangi Sharma"
		}
	],
	"bathroomrating": [
		{
			"building": "All Floors",
			"rating": 4
		}
	],
	"categories": {
		"academics": 1,
		"universitybuilding": 1,
		"location": 1
	}
};


//////////////////
// WEBPACK FOOTER
// ./src/json/danabuilding.json
// module id = 860
// module chunks = 0